import styled, { css } from "styled-components";

import { scrollYBarStyle } from "@styles/mixin";

export const PressLabelViewerContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  width: 100%;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 400;
  line-height: 145%;
  margin-top: 0.8rem;
  width: 100%;
  flex: 1;

  &:focus {
    outline: none;
  }
`;

export const PressLabelViewerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  width: 100%;
  border-radius: 0 0 0.4rem 0.4rem;
  border: 1px solid var(--grayscale-spectrum-neural-blue-gray-03, #dee5ef);
  padding: 1.6rem 1.6rem 0;
  background: #fff;
  color: #000;
  overflow-y: auto;
  max-height: calc(100vh - 305px);
  position: relative;

  ${scrollYBarStyle}
`;

export const ViewerWrapper = styled.div<{
  $start: number | null;
  $target: number | null;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  padding: 1.6rem 1.6rem 0;

  ${({ $start, $target }) =>
    $start !== null &&
    $target !== null &&
    css`
      .search-table-mark[data-start-index="${$start}"][data-table-row-index="${$target}"] {
        background-color: #0026ff !important;
        color: white;
      }
    `}
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 0.8rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2.4rem;
  height: 2.4rem;
  cursor: pointer;
`;

export const SearchControls = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  height: 100%;
`;

export const NumberText = styled.div`
  font-family: var(--font-pretendard);
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  display: flex;
  padding: 0rem var(--Spacing-12, 1.2rem);
  align-items: center;
  gap: var(--Spacing-2, 0.2rem);
  align-self: stretch;
`;

export const UpIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.8rem;
  height: 2.8rem;
  border-left: 1px solid #dee5ef;

  &:hover {
    svg {
      path {
        fill: #3d4551;
      }
    }
  }

  &:active {
    svg {
      path {
        fill: #2a2f37;
      }
    }
  }
`;

export const DownIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.8rem;
  height: 2.8rem;

  &:hover {
    svg {
      path {
        fill: #3d4551;
      }
    }
  }

  &:active {
    svg {
      path {
        fill: #2a2f37;
      }
    }
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.8rem;
  height: 2.8rem;
  padding: var(--Spacing-Btn-8, 0.28rem) var(--Spacing-Btn-16, 0.28rem);

  &:hover {
    svg {
      path {
        fill: #3d4551;
      }
    }
  }

  &:active {
    svg {
      path {
        fill: #2a2f37;
      }
    }
  }
`;

export const SearchInputWrapper = styled.div<{ searchTerm: boolean }>`
  position: relative;
  width: 100%;
  border-radius: 0.4rem 0.4rem 0 0;
  border: 1px solid var(--grayscale-spectrum-neural-blue-gray-03, #dee5ef);
  border-bottom: none;
  background: #fff;
  cursor: pointer;
  color: #a8adb5;

  ${({ searchTerm }) =>
    searchTerm &&
    css`
      ${SearchIcon} {
        svg {
          path {
            fill: #0198e9;
          }
        }
      }
    `}
`;

export const SearchInputContainer = styled.input<{ searchTerm: boolean }>`
  all: unset;
  padding: var(--Spacing-4, 0.4rem) var(--Spacing-8, 0.8rem);
  padding-left: 3.8rem;
  width: ${({ searchTerm }) => (searchTerm ? "calc(100% - 160px)" : "100%")};
  font-family: var(--font-pretendard);
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;

  &:focus {
    color: var(--Color-Common-Text-Primary, #2a2f37);
  }

  ${({ searchTerm }) =>
    searchTerm &&
    css`
      color: var(--Color-Common-Text-Primary, #2a2f37);
    `}
  ${({ searchTerm }) =>
    !searchTerm &&
    css`
      color: rgb(186, 186, 186);
      &::placeholder {
        color: rgb(186, 186, 186);
      }
    `}
`;
